import { useEffect, useState } from 'react';
import debounce from 'just-debounce';
import clsx from 'clsx';

import { getAmpConfigFlags } from 'shared/config/amp-config';
import { Tooltip } from 'shared/ui/tooltip';

import styles from './styles.module.scss';

export const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const { isNewNavigationEnabled } = getAmpConfigFlags();

  const handleClick = () => {
    window.scroll({ top: 0 });
  };

  const handleWindowScroll = () => setIsVisible(window.scrollY > 300);
  const debouncedHandleWindowScroll = debounce(handleWindowScroll, 100);

  useEffect(() => {
    window.addEventListener('scroll', debouncedHandleWindowScroll);

    return () => {
      window.removeEventListener('scroll', debouncedHandleWindowScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={clsx(styles.container, {
        [styles.visible]: isVisible,
        [styles.containerWithNewNav]: isNewNavigationEnabled,
      })}
    >
      <Tooltip title="Back to top" tooltipClassNames={styles.buttonTooltip}>
        <button
          className={clsx(
            'btn',
            'd-flex',
            'align-items-center',
            'justify-content-center',
            styles.backToTopButton,
          )}
          onClick={handleClick}
          type="button"
          aria-label="Back to top"
          data-testid="back-to-top"
        >
          <i
            className={clsx('icon-v2-chevron-small-up', styles.icon)}
            aria-hidden
          />
        </button>
      </Tooltip>
    </div>
  );
};
